let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
{
    label: '运营类别',
    props: 'isHostOperate',
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
        if (row.isHostOperate == '01') {
            return '代运营'
        }
        else if (row.isHostOperate == '02') {
            return '自运营'
        } {
            return ''
        }
    }
},
{
    label: '运营商名称',
    props: 'dealName',
    minWidth: 200,
},
{
    label: '电站名称',
    props: 'stationAddr',
    minWidth: 200,
},
{
    label: '开始时间',
    props: 'staticStartTime',
    minWidth: 200,
},
{
    label: '结束时间',
    props: 'staticEndTime',
    minWidth: 200,
},
{
    label: '订单量',
    props: 'orderCount',
    minWidth: 200,
},
{
    label: '未支付数量',
    props: 'orderUnpaidCount',
    minWidth: 200,
},
{
    label: '总电量(度)',
    props: 'chargeVal',
    minWidth: 200,
},
{
    label: '应收电费(元)',
    props: 'stationName',
    minWidth: 200,
},
{
    label: '实收电费(元)',
    props: 'actFee',
    minWidth: 200,
},
{
    label: '账户余额支付(元)',
    props: 'actPayFee',
    minWidth: 200,
},
{
    label: '度电支付(k-Wh)',
    props: 'stationName',
    minWidth: 200,
},
{
    label: '数据统计日期',
    props: 'lastModifiedWhen',
    minWidth: 200,
},
 ];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'title',
    name: '电站分析'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-表格属性
pageConfig.detailTableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'stationReport';

pageConfig.detailRouter = '';





export default pageConfig;
